import Vue from "vue";
class InventoryService {
  Remove(id) {
    return Vue.prototype.$http({
      url: "inventory/remove/" + id,
      method: "DELETE"
    });
  }

  RemoveFile(id, inventoryId) {
    return Vue.prototype.$http({
      url: "inventory/remove-file?id=" + id + "&inventoryId=" + inventoryId,
      method: "DELETE"
    });
  }

  Get(id) {
    return Vue.prototype.$http({
      url: "inventory/get/" + id,
      method: "GET"
    });
  }

  GetFiles(id) {
    return Vue.prototype.$http({
      url: "inventory/get-files/" + id,
      method: "GET"
    });
  }

  New(viewModel) {
    return Vue.prototype.$http({
      url: "inventory/new",
      data: viewModel,
      method: "POST"
    });
  }

  Edit(viewModel) {
    return Vue.prototype.$http({
      url: "inventory/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  GetGrid(page, projectId) {
    var url = "/inventory/get-grid?page=" + page + "&perPage=20";
    if (projectId)
      url = url + "&projectId=" + projectId;
    return Vue.prototype.$http({
      url: url,
      method: "GET"
    });
  }

  GetReportTable(projectId) {
    return Vue.prototype.$http({
      url: "/inventory/report/table/" + projectId,
      method: "GET"
    });
  }

}

export default new InventoryService();
